enum Experience {
  Beginner = "Beginner",
  Intermediate = "Intermediate",
  Advanced = "Advanced",
}

const experienceQuestion = {
  name: "experience",
  title: "What’s your gym experience?",
  type: "radiogroup",
  description: "Be honest—your plan adapts to your level.",
  choices: [
    {
      value: Experience.Beginner,
      text: "<div class='icon-button'><div>🚶</div><div>Beginner<br /><span class=\"small-text\">Just getting started or only recently taking it seriously</span></div></div>",
    },
    {
      value: Experience.Intermediate,
      text: "<div class='icon-button'><div>🏃‍♂️</div><div>Intermediate<br /><span class=\"small-text\">I train consistently and know my way around the gym</span></div></div>",
    },
    {
      value: Experience.Advanced,
      text: "<div class='icon-button'><div>🏋️</div><div>Advanced<br /><span class=\"small-text\">I’ve trained for years and know how to program my own workouts</span></div></div>",
    }
  ],
  isRequired: true,
};

export {
  experienceQuestion,
  Experience,
}